import { PaymentMethodEnum } from '@/types/common';
import { useSelectedPaymentMethod } from '@/hooks/useSelectedPaymentMethod';
import { StripeDirectPayForm } from './StripeDirectPayForm';
import { StripeBlikPayForm } from './StripeBlikPayForm';

export const BlikPayForm = () => {
  const { selectedPaymentMethod } = useSelectedPaymentMethod();

  // blik_checkout runs BLIK through Stripe's P24 PaymentMethod.
  if (selectedPaymentMethod === PaymentMethodEnum.BLIK_CHECKOUT) {
    return <StripeDirectPayForm paymentMethod={PaymentMethodEnum.BLIK_CHECKOUT} />;
  }

  return <StripeBlikPayForm />;
};
